import { Icon } from '@chakra-ui/react';

export default function SFPaperPlaneIcon(props) {
  return (
    <Icon
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M13.1953 20.9219C12.4688 20.9219 12.2266 20.3438 11.9922 19.5547L10.75 15.4297C10.6016 14.9062 10.625 14.6406 10.9297 14.3203L18.9062 5.71875C19 5.61719 18.9922 5.5 18.9141 5.42188C18.8359 5.35156 18.7188 5.33594 18.6172 5.42969L10.0469 13.4375C9.71094 13.75 9.42969 13.7656 8.92969 13.6094L4.71094 12.3281C3.96094 12.1016 3.41406 11.8594 3.41406 11.1406C3.41406 10.5703 3.92188 10.1719 4.57812 9.92188L18.0156 4.77344C18.375 4.63281 18.6953 4.55469 18.9609 4.55469C19.4688 4.55469 19.7812 4.86719 19.7812 5.375C19.7812 5.64062 19.7031 5.96094 19.5625 6.32031L14.4453 19.6875C14.1562 20.4375 13.7578 20.9219 13.1953 20.9219Z' />
    </Icon>
  );
}
